// src/pages/Banks/EditBank.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FormAddEditBank from '../../components/banks/FormAddEditBank';

const EditBank = () => {
    const navigate = useNavigate();

    const handleSubmitSuccess = () => {
        navigate('/banks');
    };

    return <FormAddEditBank isEdit={true} onSubmitSuccess={handleSubmitSuccess} />;
};

export default EditBank;
